import { useState } from 'react';

/**
 * StarFieldBg — 星空背景层
 * 60 颗星，闪烁动画，纯 CSS
 */
export default function StarFieldBg() {
  const [stars] = useState(() =>
    Array.from({ length: 60 }, (_, i) => ({
      id: i,
      x: Math.random() * 100,
      y: Math.random() * 55,
      size: 1 + Math.random() * 1.5,
      delay: Math.random() * 4,
      duration: 3 + Math.random() * 4,
      opacity: 0.3 + Math.random() * 0.7,
    }))
  );

  return (
    <div className="absolute inset-0 overflow-hidden">
      {stars.map((s) => (
        <div
          key={s.id}
          className="absolute rounded-full"
          style={{
            left: `${s.x}%`,
            top: `${s.y}%`,
            width: `${s.size}px`,
            height: `${s.size}px`,
            backgroundColor: `rgba(200, 220, 255, ${s.opacity})`,
            animation: `ocean-star-twinkle ${s.duration}s ease-in-out ${s.delay}s infinite`,
            boxShadow: `0 0 ${s.size * 2}px rgba(200, 220, 255, ${s.opacity * 0.5})`,
          }}
        />
      ))}
      <style>{`
        @keyframes ocean-star-twinkle {
          0%, 100% { opacity: 0.3; }
          50% { opacity: 1; }
        }
      `}</style>
    </div>
  );
}
